import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/master/pincode/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import {
  getAllCities,
  getAllCountries,
  getAllStates,
} from "../../../../features/admin/common/Slice";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Delete_Confirm_Modal from "../../../common-components/common_Modal/Delete_Confirm_Modal/Delete_Confirm_Modal";
import Confirm_Status_Change from "../../../common-components/common_Modal/Confirm_Status_Change/Confirm_Status_Change";

const Table = () => {
  const dispatch = useDispatch();

  const Permission = useSelector((state) => state.auth?.admin_info);

  const {
    pincode,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    country,
    countries,
    setCountry,
    state,
    states,
    setState,
    city,
    cities,
    setCity,
    modalMessage,
    modalShow,
    setModalShow,
  } = IndexUse();

  console.log(state, "statestate");

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [showError, setShowError] = useState("");
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const handleDeleteModal = async (id) => {
    await setDeleteConfirmModal(id);
  };

  const handleDelete = async (id) => {
    await setDeleteConfirmModal(false);
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);

    if (success) {
      await fetch();
      setRDelete(false);
      setStatusConfirmModal(false);
    } else {
      setErr(true);
    }
  };

  const [statusConfirmModal, setStatusConfirmModal] = useState(false);
  const handleStatusModal = async (id) => {
    await setStatusConfirmModal(id);
  };

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        {" "}
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title="Pincode " alltotal="" />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <div className="form-group">
                <label className="form-label">Filter by Country</label>
                <Select
                  name="country_id"
                  value={country}
                  options={countries}
                  placeholder={"Country"}
                  onInputChange={() => {
                    dispatch(getAllCountries());
                  }}
                  onChange={(val) => {
                    setCountry(val);
                    fetch();
                  }}
                />
              </div>
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by State</label>
              <Select
                name="state_id"
                value={state}
                options={states}
                placeholder={"State"}
                onInputChange={(val) => {
                  if (country) {
                    dispatch(
                      getAllStates({ countryId: country.value, name: val }),
                    ); // Fetch only states of selected country
                  }
                }}
                onChange={(val) => {
                  setState(val);
                }}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by City</label>
              <Select
                name="city_id"
                value={city}
                options={cities}
                placeholder={"City"}
                onInputChange={(val) => {
                  if (state) {
                    dispatch(getAllCities(state.value));
                  }
                }}
                onChange={(val) => {
                  setCity(val);
                  setState(val?.state_id);
                }}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Pincode</label>
              <Form.Control
                type="text"
                placeholder="Enter Pincode"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger"
                onClick={() => {
                  setCountry("");
                  setState("");
                  setName("");
                  setCity("");
                }}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      {Permission.includes(IDS.Permission.Pincode.Add) && (
        <Add
          id={id}
          setId={setId}
          setSuccess={setSuccess}
          setErr={setErr}
          showError={showError}
          setShowError={setShowError}
        />
      )}

      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S. no.</th>
                <th>Country </th>
                <th>State </th>
                <th>City </th>
                <th>Pincode </th>
                {Permission.includes(IDS.Permission.Pincode.Edit) && (
                  <th>status </th>
                )}
                {Permission.includes(IDS.Permission.Pincode.Delete) && (
                  <th>Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {pincode?.data?.data?.length > 0 ? (
                pincode?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      {(pincode?.data?.current_page - 1) *
                        pincode?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.Country?.name}</td>
                    <td>{val?.State?.name}</td>
                    <td>{val?.City?.name}</td>
                    <td>{val?.name}</td>
                    {Permission.includes(IDS.Permission.Pincode.Edit) && (
                      <td>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${val?.id}`}
                          checked={val?.status}
                          onClick={() => handleStatusModal(val?.id)}
                          label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                        />
                      </td>
                    )}

                    <td>
                      <div className="action_btns">
                        {/* <button type="button" className='editbtn'>
                                                    <Link><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/icons/view.png'} /></Link>
                                                </button> */}
                        {Permission.includes(IDS.Permission.Pincode.Edit) && (
                          <button
                            type="button"
                            className="editbtn"
                            onClick={() => {
                              setId(val?.id);

                              setTimeout(() => {
                                const element = document.querySelector(
                                  ".content_body",
                                );

                                if (element) {
                                  element.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                } else {
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                }
                              }, 100);
                            }}
                          >
                            <Link>
                              <img
                                className="icon"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/edit.png"
                                }
                              />
                            </Link>
                          </button>
                        )}
                        {Permission.includes(IDS.Permission.Pincode.Delete) && (
                          <button
                            type="button"
                            className="editbtn"
                            onClick={() => handleDeleteModal(val?.id)}
                          >
                            <Link>
                              <img
                                className="icon"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/delete.png"
                                }
                              />
                            </Link>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Delete_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Delete_Confirm_Modal
        handleDelete={handleDelete}
        show={deleteConfirmModal}
        onHide={() => setDeleteConfirmModal(false)}
      />

      <Confirm_Status_Change
        handleStatusChange={handleStatusChange}
        show={statusConfirmModal}
        onHide={() => setStatusConfirmModal(false)}
      />
      <Pagination_Holder
        onPageChange={pincode?.data?.current_page}
        totalPages={pincode?.data?.total_pages}
        handlePageChange={handlePageChange}
      />
    </section>
  );
};

export default Table;
